module.exports = __webpack_public_path__ + "img/1.12.1_Russian_road_sign.0dd162fc.svg";